import * as SentryReact from "@sentry/react";

let clientInitialized = false;

export function initSentryClient() {
  if (clientInitialized || typeof window === "undefined") return;

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  SentryReact.init({
    dsn,
    environment: import.meta.env.DEV ? "development" : "production",
    tracesSampleRate: 0,
  });
  clientInitialized = true;
}

export function captureException(error: unknown, context?: Record<string, unknown>) {
  // Client-side only — use @sentry/react
  // Server-side errors are captured by logger.error() and will be
  // picked up by Sentry's server-side integration when configured
  if (typeof window !== "undefined") {
    SentryReact.captureException(error, { extra: context });
  }
}
